import React from 'react';
import './FrameworkSection.css';

const frameworkItems = [
  {
    number: '01',
    title: 'People',
    subtitle: 'PRECISION HIRING',
    description: 'Strategic Talent Acquisition · Employer Branding · Leadership Assessment & Development · Talent Market Intelligence'
  },
  {
    number: '02',
    title: 'Roles',
    subtitle: 'CLEAR ARCHITECTURE',
    description: 'Organizational Design · Structure Assessment · Job Architecture · Talent Infrastructure & Systems'
  },
  {
    number: '03',
    title: 'Skills',
    subtitle: 'FUTURE READY',
    description: 'Executive Coaching · Leadership Development · Performance Management · Career Development & Succession'
  },
  {
    number: '04',
    title: 'Environment',
    subtitle: 'CULTURE PERFORMS',
    description: 'Executive Team Culture Shaping & Alignment · Culture Assessment & Strategy · Employee Relations · Change Management · Workplace Wellbeing Programs · Workforce Engagement'
  },
  {
    number: '05',
    title: 'Incentives',
    subtitle: 'REWARDS INSPIRE',
    description: 'Compensation & Benefits Strategy · Total Rewards Design · Performance Incentive Programs · Recognition Systems'
  },
  {
    number: '06',
    title: 'Time',
    subtitle: 'ANTICIPATE NEEDS',
    description: 'Succession Planning · Talent Analytics & Reporting · Talent Technology Solutions · Compliance & Risk Management'
  }
];

const FrameworkSection = () => {
  return (
    <section id="framework" className="framework-section">
      <div className="framework-container">
        <div className="framework-header">
          <div className="section-label">The Right 6™ Framework</div>
          <h2 className="section-title">Six interconnected dimensions that define organizational talent excellence</h2>
        </div>
        
        <div className="framework-grid">
          {frameworkItems.map((item, index) => (
            <div key={index} className="framework-item">
              <div className="framework-number">{item.number}</div>
              <h3 className="framework-title">{item.title}</h3>
              <p className="framework-subtitle">{item.subtitle}</p>
              <p className="framework-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FrameworkSection;